// extracted by mini-css-extract-plugin
export var inline = "_wh-0";